import Playground from './Playground';
import User from './User';
export default class UserDetail extends User {
  // userId: String;
  // name: String;
  managingPlaygrounds: Playground[];
  enteredPlaygrounds: Playground[];
}
